import { useEffect, useState } from "react";

import { api } from "@/api";
import { GoogleLogo, Stars } from "@/components/ReviewsSection";

const Card = ({ r, hidden }) => (
  <article className="lp-mqcard" aria-hidden={hidden || undefined} data-testid={hidden ? undefined : "marquee-review-card"}>
    <header>
      <span className="lp-rvavatar">{r.author.trim()[0]?.toUpperCase()}</span>
      <div><strong>{r.author}</strong>{r.date && <small>{r.date}</small>}</div>
      <GoogleLogo size={14} />
    </header>
    <Stars value={r.rating} size={13} />
    <p>{r.text}</p>
  </article>
);

export function LandingMarquee() {
  const [reviews, setReviews] = useState([]);
  useEffect(() => { api.get("/public/reviews").then(({ data }) => setReviews((data.reviews || []).filter((r) => r.text))).catch(() => {}); }, []);
  if (!reviews.length) return null;
  return (
    <section className="lp-marquee" aria-label="Avis clients Google" data-testid="reviews-marquee">
      <div className="lp-mqtrack" style={{ "--mq-dur": `${reviews.length * 7}s` }}>
        {reviews.map((r, i) => <Card key={`a-${i}`} r={r} />)}
        {reviews.map((r, i) => <Card key={`b-${i}`} r={r} hidden />)}
      </div>
    </section>
  );
}
